<template>
	<div class="mt-2 px-0">
		<table class="table table-responsive table-sm">
			<thead class="text-white">
			<tr>
				<th class="text-start">Token</th>
				<th v-if="!compact" class="text-start d-none d-xl-table-cell">Address</th>
				<th class="text-end">Amount</th>
				<th class="text-end d-none d-md-table-cell">Price</th>
				<th class="text-end">Total</th>
				<th v-if="!compact" class="text-end">Actions</th>
			</tr>
			</thead>
			<tbody v-if="!pricesLoaded">
			<tr>
				<td colspan="6" class="text-center"><p class="my-4">Loading Portfolio...</p></td>
			</tr>
			</tbody>
			<tbody v-else>
			<BotRow v-for="(position) in positions" @swap="onSwap" :compact="compact" :showRugs="showRugs" :position="position"
					:price="getTokenPrice(position.account.data.parsed.info.mint)"
					:key="position.account.data.parsed.info.mint"></BotRow>
			</tbody>
		</table>

		<div class="row">
			<div class="col-12">
				<button class="btn btn-outline-primary w-100 px-2" @click="toggleRugs">{{ showRugs ? 'Hide' : 'Show' }} Unknown Tokens</button>
			</div>
		</div>
	</div>
</template>

<script>
import {web3} from "@project-serum/anchor";
import BotRow from "@/views/bot/BotRow.vue";
import {useAlertStore, useCacheStore, useWalletStore} from "@/pinia";
import {mapStores} from "pinia";

export default {
	name: "TokenPortfolio",
	components: {BotRow},
	props: {
		address: {
			type: web3.PublicKey,
			required: true,
		},
		compact: {
			type: Boolean
		},
		source: {
			type: String
		}
	},
	data() {
		return {
			pricesLoaded: false,
			showRugs: false,
			solBalance: 0,
			positions: [],
			tokenPrices: {},
			reloadInterval: null
		}
	},
	computed: {
		...mapStores(useCacheStore),
		queryID: function() {
			return window.Telegram?.WebApp?.initDataUnsafe?.query_id
		}
	},
	methods: {
		toggleRugs: function () {
			return this.showRugs = !this.showRugs
		},

		getTokenPrice: function (mint) {
			if (!this.tokenPrices) {
				return 0
			}
			return this.tokenPrices[mint] || 0
		},

		getPortfolio: function () {
			this.$store.state.solana.tokenClient.getSolBalance(this.address).then(r => {
				this.solBalance = r
				this.$emit("sol", this.solBalance)

				this.getUserTokenBalances()
			})

			//Get T1 Balances
			//Get T2 Balances
		},

		getUserTokenBalances: function() {
			this.$store.state.solana.tokenClient.getUserTokenIndex(this.address).catch(e => {
				console.error("Failed to get user tokens", e)
			}).then(r => {
				this.positions = r.filter(rx => {
					if (rx.account?.data.parsed.info.mint === "So11111111111111111111111111111111111111112")
						return false

					return rx.account?.data.parsed.info.tokenAmount.amount > 1
				})


				this.positions.push({
					address: this.address,
					pubkey: "So11111111111111111111111111111111111111112",
					account: {
						owner: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
						data: {
							parsed: {
								info: {
									mint: "So11111111111111111111111111111111111111112",
									owner: this.address,
									tokenAmount: {
										amount: this.solBalance,
										decimals: 9,
										uiAmount: this.solBalance / Math.pow(10, 9),
										uiAmountString: `${this.solBalance / Math.pow(10, 9)}`
									}
								}
							}
						}
					}
				})

				this.fetchPrices(this.positions.map(rx => {
					// if (rx.account.data.parsed.info.mint === "So11111111111111111111111111111111111111112")
					// 	this.solBalance += rx.account.data.parsed.info.tokenAmount.amount

					return rx.account?.data.parsed.info.mint
				}))

				this.$emit("positions", this.positions)
			})
		},


		onSwap: function (mint) {
			if (this.source === "fluxbeam") {
				this.$router.push(`/app/swap?inMint=${mint}&outMint=So11111111111111111111111111111111111111112`)
				return
			}

			if (this.queryID) {
				// fetch(`http://localhost:8081/webapp/${this.queryID}/${mint}`, {
				fetch(`https://bot-api.fluxbeam.xyz/webapp/${this.queryID}/${mint}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						query: this.queryID,
						method: "ca",
						data: `pf ${mint}`
					})
				})
				return
			}

			const baseURI = `https://t.me/fluxbeam_bot?start=ca-${mint}_pf` //Indicate the call is coming from portfolio
			window.open(`${baseURI}`)
		},



		refreshPortfolio: async function(mints) {
			const resp = await fetch(`https://data.fluxbeam.xyz/prices?ids=${mints}`);
			const data = await resp.json();

			const keys = Object.keys(data?.data)
			for(let i = 0; i < keys.length; i++) {
				const d = data?.data[keys[i]]
				this.cacheStore.addTokenPricesUSD({mint: keys[i], priceUSD: d, updateAt: new Date()})
			}

			return data.data
		},

		fetchPrices: async function (mints) {
			this.tokenPrices = await this.refreshPortfolio(mints)
			this.pricesLoaded = true
			this.sortPortfolioByValue()
			this.calculatePortfolioValue()
			this.$emit("prices", this.tokenPrices)
		},

		sortPortfolioByValue: function () {
			this.positions = this.positions.sort((a, b) => {
				a.totalPrice = this.getTokenPrice(a.account.data.parsed.info.mint) * a.account.data.parsed.info.tokenAmount.uiAmount
				b.totalPrice = this.getTokenPrice(b.account.data.parsed.info.mint) * b.account.data.parsed.info.tokenAmount.uiAmount
				return b.totalPrice - a.totalPrice
			})
		},

		calculatePortfolioValue: function () {
			let total = 0

			this.positions.forEach((p) => {
				total += p.totalPrice
			})

			this.$emit("total", total)
		},
	},
	mounted() {
		this.getPortfolio()
		this.reloadInterval = setInterval(() => {
			this.refreshPortfolio(this.positions.map((p) => p.mint));
		}, 10_000);
	},
	beforeDestroy() {
		clearInterval(this.reloadInterval)
	}
}
</script>

<style scoped>
tr {
	cursor: pointer;
}
th td:last-child {
	width: 1%;
	white-space: nowrap;
}
</style>